module.exports = __webpack_public_path__ + "img/charming.186585ee.jpg";